import React, { useState, useEffect } from 'react';

import clienteAxios from '../config/axiox';


function Login({
    usuario, setUsuario, clave, setClave, setNombre, setPerfil, setformLogin, setLoginON
}) {
      
    const [msgError, setMesgError]=useState("");
    const [msgOK, setMsgOK]=useState("");

    useEffect(()=>{    
          
    },[msgError]) 

    const IniciarSesion= async(event)=>{                       
        if( [usuario, clave].includes('')){
            setMesgError("Debe ingresar todos los datos")
        }else{
            const data ={   
                "sp":"usuarios_menus",         
                "op":"validar_usuario",         
                "celular":usuario,                
                "clave":clave
              }
              const config = {
                headers: {
                    "Content-Type": "application/json",      
                },
                data:data        
              }  
              
              await clienteAxios.post(`api/sp`, data, config)
              .then(res=>{
                
                let datos=res.data.data[0][0]                                
                let {idusuario, celular, nombre, correo, casa, clave, activo, idperfil, acceso, mensaje, perfil}=datos
               
                if(acceso==0){
                    setMesgError(mensaje)
                   
                }
                
                if(activo===1){                  
                  setNombre(nombre)
                  setPerfil(idperfil)
                  setformLogin(false)
                  setLoginON(true)
                }
                
                       
            }).catch(err=>{             
                  
                console.log(err)
            });    
             
        }
    }
    const Cancelar= async()=>{   
        setformLogin(false)     
    }
    return(
        <>
         
            <form onSubmit={IniciarSesion}>
                <div className="mx-auto w-full p-5 bg-white rounded-xlg grid sm:grid-cols-1 sm:my-4 md:w-1/2 md:my-12 lg:w-1/3 lg:my-12">
                <div clasename='justify-center'>
                    <label className="label_form">Usuario</label>
                    <input 
                        type="email" 
                        className="form_control" 
                        placeholder="correo@dominio.com" 
                        required 
                        value={usuario} 
                        onChange={({target: {value}})=>setUsuario(value)} />  
                </div> 
                <div clasename='justify-center'>
                    <label className="label_form pt-2">Clave</label>
                    <input 
                        type="password" 
                        className="form_control"                 
                        required                         
                        value={clave} 
                        onChange={({target: {value}})=>setClave(value)} 
                        />            
                </div>
                {msgOK &&                         
                    <div className='w-full bg-green-600 text-white block p-2 my-2'>
                        <span >{msgOK}</span>
                    </div>
                }
                {msgError &&                         
                    <div className='w-full bg-red-600 text-white block p-2 my-2'>
                        <span >{msgError}</span>
                    </div>
                }
                <div clasename='justify-end'>
                    <button type="button" className="boton_azul" onClick={()=>IniciarSesion()}>Ingresar</button>
                    <button type="button" className="boton_gris" onClick={()=>Cancelar()}
                    >Cancelar</button>
                </div>        
                </div>    
            </form>    
       
        </>
    )
}

export default Login;